import React from "react";
import "react-vis/dist/style.css";
import {
  XYPlot,
  XAxis,
  YAxis,
  VerticalBarSeries,
  HorizontalGridLines,
  LabelSeries,
} from "react-vis";

import "./Chart.scss";

import {
  statsBooleanColorPalette,
  statsColorPalette,
} from "../../store/reducers/dataReducer";

const componentToHex = (c) => {
  const hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
};

const rgbToHex = (r, g, b) => {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
};

const Chart = (props) => {
  const { selectedAttribute, stats } = props;

  const colorRange =
    stats.type === "boolean"
      ? statsBooleanColorPalette.map((color) => rgbToHex(...color))
      : statsColorPalette.map((color) => rgbToHex(...color));

  const width = stats.type === "boolean" ? 200 : 300;

  let series = [];

  if (stats.type === "boolean") {
    series = [
      {
        x: 1,
        y: stats.ranges[0],
        color: colorRange[0],
        label: "No",
        yOffset: -3,
        style: { fontSize: 10 },
      },
      {
        x: 2,
        y: stats.ranges[1],
        color: colorRange[1],
        label: "Yes",
        yOffset: -3,
        style: { fontSize: 10 },
      },
    ];
  } else {
    for (let i = 0; i < 5; i++) {
      series.push({
        x: i,
        y: i + 1,
        color: colorRange[i],
        label: stats.ranges[i].label,
        yOffset: -3,
        style: { fontSize: 10 },
      });
    }
  }

  return (
    <div className="chart">
      <XYPlot height={200} width={width} colorType="literal">
        <XAxis
          position="middle"
          hideTicks
          title={
            stats.type === "percentage"
              ? selectedAttribute === "Gender"
                ? "Gender (% female)"
                : selectedAttribute + " (% of customers)"
              : selectedAttribute
          }
          top={180}
        />
        {stats.type === "boolean" && <YAxis />}
        <VerticalBarSeries data={series} />
        <LabelSeries
          data={series}
          labelAnchorX="middle"
          labelAnchorY="text-top"
        />
      </XYPlot>
    </div>
  );
};

export default Chart;
